import { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "Components/Navbar/Navbar";

export default function AdminLayout() {
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("darkMode") === "true",
  );
  const toggleDark = () =>
    setDarkMode((d) => {
      localStorage.setItem("darkMode", String(!d));
      return !d;
    });

  return (
    <div className={darkMode ? "dm" : ""}>
      <Navbar toggleDark={toggleDark} darkMode={darkMode} />
      <Outlet />
    </div>
  );
}
